<template>

  <b-row v-if="esOtorrino">
    <b-col>
      <b-card
      
        no-body
        :class="{ 'open': visibleBody }"
      >
        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font: 45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGÍA OTORRINOLARINGOLÓGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem 2rem">

            <InfoFuma class="my-3"/>

            <hr>

            <b-row class="my-3 mx-1 d-flex align-items-center">
              <b-form-checkbox 
                switch 
                v-model="drogas.active"
                class="col-2"
              >
                Drogas
              </b-form-checkbox>

              <v-select
                v-if="drogas.active"
                class="col"
                placeholder="Seleccione los tipos de drogas"
                :options="drogasOpts"
                :reduce="option => option"
                label="text"
                :multiple="true"
                taggable
                @input="newArray => drogas.selected = onAddNewOpt(newArray)"
              />
            </b-row>
  

            <hr>

            <b-row class="my-3 mx-1">
              <b-form-checkbox 
                switch 
                v-model="alcohol"
                class="col"
              >
                Alcohol
              </b-form-checkbox>

              <b-form-checkbox 
                switch 
                v-model="ruido"
                class="col"
              >
                Exposicion ruido
              </b-form-checkbox>
            </b-row>

            <hr>

            <b-row class="my-3 d-flex align-items-center">
              <label class="col-3">Vacunas</label>
              <v-select
                class="col"
                placeholder="Seleccione las vacunas"
                :options="vacunasOpts"
                :reduce="option => option"
                label="text"
                :multiple="true"
                taggable
                @input="newArray => vacunas.selected = onAddNewOpt(newArray)"
              />
            </b-row>

            <hr>

            <b-row class="my-3 d-flex align-items-center">
              <label class="col-3">Alergias Respiratorias</label>
              <v-select
                class="col"
                placeholder="Seleccione las vacunas"
                :options="alergiasOpts"
                :reduce="option => option"
                label="text"
                :multiple="true"
                taggable
                @input="newArray => alergias.selected = onAddNewOpt(newArray)"
              />
            </b-row>

            <hr>

            <OtorrinoSintomas class="my-3"/>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState }  from 'vuex';
import { addNewOpt } from '@/shared/helpers';
import vSelect  from "vue-select";
import InfoFuma from './InfoFuma.vue';
import OtorrinoSintomas from './OtorrinoSintomas.vue';

export default {
  name: "SemiologiaOtorrino",

  components: {
    vSelect,
    InfoFuma,
    OtorrinoSintomas
  },

  data() {
    return {
      visibleBody: true,

      drogas:{
        active : false,
        selected : [],
      },

      vacunas:{
        selected: [],
      },

      alergias:{
        selected: [],
      },

      alcohol:false,
      ruido:false,

      drogasOpts:[
        { value: 'estimulantes',  text: 'Estimulantes' },
        { value: 'alucinogenos',  text: 'Alucinogenos' },
        { value: 'cannabinoides', text: 'Cannabinoides' },
        { value: 'inhalantes',    text: 'Inhalantes' },
      ],

      vacunasOpts: [
        { value: "bcg",           text: "BCG" },
        { value: "hepatitis_b",    text: "Hepatitis B" },
        { value: "influenza",     text: "Influenza" },
        { value: "dtp",           text: "Dpt" },
        { value: "pentavalente",  text: "Pentavalente" },
        { value: "varicela",      text: "Varicela" },
        { value: "vph",           text: "VPH" },
        { value: "rotavirus",     text: "Rotavirus" },
        { value: "fiebre_amarilla", text : "Fiebre Amarilla" },
        { value: "neumococo",     text: "Neumococo" },
        { value: "polio",         text: "Polio" },
        { value: "covid",         text: "Covid 19" },
      ],

      alergiasOpts: [
        { value: "polen",                text: "Polen" },
        { value: "acaros_del_polvo",     text: "Ácaros del polvo" },
        { value: "moho",                 text: "Moho" },
        { value: "caspa_de_animales",    text: "Caspa de animales" },
        { value: "cucarachas",           text: "Cucarachas" },
        { value: "esporas_de_hongos",    text: "Esporas de hongos" },
        { value: "plumas",               text: "Plumas" },
        { value: "ciertos_alimentos",    text: "Ciertos alimentos" },
        { value: "algunos_medicamentos", text: "Algunos medicamentos" },
        { value: "latex",                text: "Látex" }
      ]

    };
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

  },

  watch: {

    drogas:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { drogas:newValue } );
      }
    },

    vacunas:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { vacunas:newValue } );
      }
    },

    alergias:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { alergias:newValue } );
      }
    },

    alcohol:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { alcohol:newValue } );
      }
    },

    ruido:{
      deep: true,
      handler(newValue){
        this.$store.commit("setOtorrino", { ruido:newValue } );
      }
    },

    stSemOtorrino:{
      deep: true,
      handler(newValue){
        const semiologia = { tipo:'otorrino', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
    },
  },

  computed: {
    ...mapState({
      stSemOtorrino: state => state.atencionCita.semiologias?.semOtorrino,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esOtorrino(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000136';
    },
  },

};
</script>
